import { render, staticRenderFns } from "./TableProducts.template.vue?vue&type=template&id=a5fa5612&scoped=true&"
var script = {}
import style0 from "./TableProducts.template.vue?vue&type=style&index=0&id=a5fa5612&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa5612",
  null
  
)

export default component.exports